<template>
  <ui-kit-select
    :value="selectedGame"
    :items="activeGames"
    :list-view="!isMobile"
    :label="isMobile ? '' : 'Game menu'"
    :placeholder="isMobile ? 'Game menu' : ''"
    can-have-empty-value
    title-field="fullTitle"
    class="blog-filter-item__game"
    @input="navigateToGame" />
</template>

<script>
import { mapState } from 'vuex';
import GameModel from 'Models/GameModel';
import UiKitSelect from 'Components/ui/Select/UiKitSelect.vue';

export default {
  name: 'BlogFilterGame',

  components: {
    UiKitSelect,
  },

  props: {
    isMobile: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState('blog', ['activeGame']),

    activeGames() {
      return GameModel.LIST_WITH_ARTICLES.map((game) => ({
        ...game,
        image: GameModel.getGameLogo(game.id),
      }));
    },

    selectedGame() {
      const activeGameId = this.activeGame?.id || null;
      return this.activeGames.find((game) => game.id === activeGameId);
    },
  },

  methods: {
    navigateToGame(game) {
      const routeToNavigate = {
        name: 'blog__root',
        params: {
          gameNamespace: game?.routeNamespace,
        },
      };

      this.$router.push(routeToNavigate);
    },
  },
};
</script>

<style lang="scss" scoped>
  .blog-filter-item__game {
    --elements-color: #{$color--basic-light-gray};
    --bg-color: #{$color--basic-dark-gray};
    --head-color: #{$color--basic-light-gray};
    --head-color--open: #{$color--basic-light-gray};
  }

  @media screen and #{$screen-more-or-1280} {
    .blog-filter-item__game {
      --font-size: 15px;
      --img-size: 32px;
      --border-radius: 15px;
      --font-size--with-label: 13px;
      --bg-color: #{$color--basic-menu};
      --elements-color: #{$color--basic-dark-gray};
    }
  }
</style>
